export const filters = [
  {
    name: "is_recommended",
    label: "Recommended"
  },
  {
    name: "is_premium",
    label: "Premium"
  },
  {
    name: "is_claimed",
    label: "Claimed"
  },
  {
    name: "first_name",
    label: "First name"
  },
  {
    name: "last_name",
    label: "Last name"
  },
  {
    name: "speciality",
    label: "Speciality"
  },
  {
    name: "state",
    label: "State"
  },
  {
    name: "city",
    label: "City"
  },
  {
    name: "healthcare_professionals",
    label: "Healthcare Professionals Name"
  },
  {
    name: "non_for_profit_name",
    label: "Non-For-Profit Name"
  },
  {
    name: "clinic_name",
    label: "Clinic Name"
  },
  {
    name: "hospital_name",
    label: "Hospital Name"
  },
  {
    name: "category",
    label: "Business Category"
  },
  {
    name: "business_name",
    label: "Business Name"
  },
  {
    name: "gender",
    label: "Gender"
  },
];
